exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table.table.call-tracking-platforms tbody>tr>td[data-v-299c3153]{vertical-align:middle}table.table.call-tracking-platforms a[data-v-299c3153]:hover{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-299c3153","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/clients/CallTrackingPlatformList.vue
// module id = OHRw
// module chunks = 0